<template lang="pug">
  #welcome.container
    component(:is="customerComponent")

</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: "Welcome",
    
    components: {
      ReturnCustomer: () => import('./ReturnCustomer'),
      ReturnVisitor: () => import('./ReturnVisitor'),
    },

    computed: {
      ...mapState('customer', ['cdata']),

      customerComponent() {
        return this.cdata.visitorType.toLowerCase() !== 'return buyer' ? 'ReturnVisitor' : 'ReturnCustomer';
      }
    },
  }
</script>
